import React from "react";
import { NavLink } from "react-router-dom";

import { useDispatch } from "react-redux";
import { setParams } from "../../action/actions";

const SidebarLink = (props) => {
  console.log("propsprops", props);

  const dispatch = useDispatch();
  return (
    <div
      onClick={() => {
        props.closeSidebar();
        dispatch(setParams({}));
      }}
    >
      {!!props.disable
        ? props.name !== "About" && (
            <div
              className="list-group-item list-group-item-action border-0 py-2 mb-1 rounded"
              style={{
                background: "#f6f9fc",
                cursor: "no-drop",
              }}
            >
              <i className={"fa " + props.icon} />
              <span className="ml-2"> {props.name} </span>
            </div>
          )
        : props.name !== "About" && (
            <NavLink
              className="list-group-item list-group-item-action border-0 py-2  mb-1 rounded"
              exact={props.exact ? true : false}
              to={props.to}
            >
              <i className={"fa " + props.icon} />
              <span className="ml-2" style={{ fontSize: props.fontSize }}>
                {" "}
                {props.name}{" "}
              </span>
            </NavLink>
          )}
    </div>
  );
};

export default SidebarLink;
